import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRing = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.a{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(5 2)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M12,3.5V2",
					transform: "translate(-5 -2)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M8.512,8.907l.2-.38A1,1,0,0,1,9.6,8H14.4a1,1,0,0,1,.881.526l.2.38a1,1,0,0,1-.221,1.225L12.661,12.42a1,1,0,0,1-1.32,0L8.734,10.131a1,1,0,0,1-.222-1.224Z",
					transform: "translate(-5 -2)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M18,6l1-1",
					transform: "translate(-5 -2)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M6,6,5,5",
					transform: "translate(-5 -2)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M9.75,11.024a5.248,5.248,0,1,0,4.5,0",
					transform: "translate(-5 -2)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M0,0H24V24H0Z"
		})
	]
});
export default SvgRing;
